import { useMutation, useQueryClient } from '@tanstack/react-query'
import supabase from 'lib/supabase-browser'
import { GeneratedContent } from 'lib/types/generated-types'
import { useAuth } from 'util/auth'

export const useCreateGeneratedContent = () => {
  const queryClient = useQueryClient()
  const { user } = useAuth()

  return useMutation(
    async (
      generatedContentToInsert: Omit<
        Partial<GeneratedContent>,
        'project_id'
      > & {
        project_id: number
      }
    ) => {
      const { data, error } = await supabase
        .from('generated_content')
        .insert([{ ...generatedContentToInsert, owner: user ? user.id : '' }])
        .select('id')
        .single()
      if (error) throw error
      return data
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries(['generated_content'])
        queryClient.invalidateQueries(['balance'])
      },
    }
  )
}
